import React from 'react';
import Container from 'components/v2/container';
export default function TestErrorPage() {
    function handleClick() {
        throw new Error('Trigger an error!');
    }
    return (React.createElement(Container, { className: "my-10" },
        React.createElement("button", { className: "btn", onClick: handleClick }, "Throw an error!")));
}
